import api from "../../../veracityapi";
import { getStartTimeStampFromString, getEndTimeStampFromString } from "../../../SharedComponents/DateManager";

/**
 * Function to fetch reporting results table data based on selected filters.
 * @param {Object} params - Parameters for fetching reporting results.
 * @param {Object} params.timeRange - The time range for which to fetch data.
 * @param {Map} params.botTypesToShow - A Map containing bot types (i.e. ghost, scanner, thief...) to filter the results.
 * @param {Map} params.botCountriesToShow - A Map containing bot countries to filter the results.  
 * @param {number} [params.limit=10] - The number of results to return per page.
 * @param {number} [params.page=1] - The page number to fetch. * 
 * @returns {Promise<Object>} - A promise that resolves to the reporting results table data.
 */

export function getReportingResultsTableData(params) {
    console.log("getReportingResultsTableData ", params )
    const websiteGUID = localStorage.getItem('selected_site');
    const startOfRange = getStartTimeStampFromString(params.timeRange.timeRange);
    const endOfRange = getEndTimeStampFromString(params.timeRange.timeRange);
    let limit = params.limit || 10;
    let page = params.page || 1;
 
    const getReportingResultsTableData = new Promise((resolve, reject) => {
        //Query params for filtering bot types
        const queryParams = {};

        //convert filtered states into arrays suitable for API query
        //Add bots by their type or catergory filter into the query params
        if(params.botTypesToShow) {            
            queryParams.included_bots = Array.from(params.botTypesToShow)
            .filter(([key, value]) => value)
            .map(([key]) => key);
        };

        //Add bots by their country filter into the query params
        if(params.botCountriesToShow) {            
            queryParams.included_countries = Array.from(params.botCountriesToShow)
            .filter(([key, value]) => value)
            .map(([key]) => key);
        };

        //Add bots by their country filter into the query params
        if(params.botThreatsToShow) {            
            queryParams.included_threat_level = Array.from(params.botThreatsToShow)
            .filter(([key, value]) => value)
            .map(([key]) => key);
        };

        /**
        * @todo merge Martins code with this one lots of conflicts
        */

        console.log("queryParams: ", queryParams);
        //call updated filtered list of finished sessions        
        api.paged(`/sessions/bot/finished/website/${websiteGUID}/${startOfRange}/${endOfRange}`, limit, page, queryParams)//This Calls {VeracityAPI::GET_finishedBotSessionsCustom}
            .then(res => {
                resolve(res);
            }).catch((error) => {
                api.handleError(error);
            });
    });

    return new Promise((resolve, reject) => {
        Promise.all([getReportingResultsTableData]).then(async (values) => {
            const temp = {
                timeRange: params.timeRange.timeRange,
            };
            for (let obj of values) {
                Object.assign(temp, obj);
            };
            resolve(temp);
        }).catch((error) => {
             reject(error)
        });
    });
}